import React from 'react';

interface ISearchOverridesContext {
  textQueryParamOverride: string;
}

export default React.createContext<ISearchOverridesContext>({ textQueryParamOverride: null });
